import { Grid2 as Grid, Skeleton, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import Help from "../common/Help";

type FilterGridRowProps = PropsWithChildren & {
  label: string;
  helpText?: string;
  indent?: number;
  loading?: boolean;
  fullWidth?: boolean;
};

export default function FilterGridRow({
  label,
  helpText,
  indent = 0,
  loading = false,
  children,
  fullWidth = false,
}: FilterGridRowProps) {
  return (
    <>
      <Grid size={fullWidth ? 12 : 3} pl={indent}>
        <Typography variant='subtitle2'>
          {label}
          {helpText ? <Help text={helpText} /> : null}
        </Typography>
      </Grid>
      <Grid size={fullWidth ? 12 : 9}>
        {loading ? <Skeleton variant="text" sx={{ mt: 1 }} /> : children}
      </Grid>
    </>
  );
}
